import { useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TabNav } from '@/components/layout/TabNav';
import { resolveActiveTab } from '@/components/layout/resolveActiveTab';

export interface PartnerTabItem {
  value: string;
  labelKey: string;
  /** Absolute partner-area route, e.g. '/partner/organization/users'. */
  to: string;
}

/**
 * Partner-area tab navigation. Reuses the shared TabNav primitive (same look +
 * route-based behaviour as the customer app and admin area). The whole partner
 * settings area is partner_admin-only, gated at the page level, so tabs need no
 * per-tab role/subject gating of their own.
 */
export function PartnerTabsNav({ tabs }: { tabs: PartnerTabItem[] }) {
  const { t } = useTranslation();
  const location = useLocation();
  // Partner routes carry no $slug segment, so the slug is irrelevant here.
  const activeTab = resolveActiveTab(tabs, location.pathname, '');

  return (
    <TabNav
      tabs={tabs.map((tab) => ({ value: tab.value, label: t(tab.labelKey), to: tab.to }))}
      activeTab={activeTab}
      slug=""
    />
  );
}
